export enum UserManagementEnum {
    MODULE_ACCESS = 'View',
    CREATE = 'Create',
    UPDATE = 'Update',
    DELETE = 'Delete',
    SEARCH = 'Search',
    ACTIVATEDEACTIVATE = 'Update_Status',
}
